export default __webpack_public_path__ + "static/media/Diabetic-Foot-1.9593f0c4.jpg";